import React from 'react';

import PrintIcon from '@material-ui/icons/Print';

import { printContainer, printTable, printButtonBase, buttonContainer } from './styles.css';

export default function PrintDialog({ shown, data, headers, onClose }) {
  return shown ? <div className={printContainer}>
    <table className={printTable}>
      <thead>
        <tr>
          {headers.map(header => <th key={`header_${header}`}>{header}</th>)}
        </tr>
      </thead>

      <tbody>
        {
          data.map(row => <tr key={row}>
            {row.map(col => <td key={col}>{col}</td>)}
          </tr>)
        }
      </tbody>
    </table>

    <div className={buttonContainer}>
      <button className={printButtonBase} onClick={onClose}>&times;</button>
      <button className={printButtonBase} onClick={window.print}><PrintIcon /></button>
    </div>
  </div> : null;
}
